/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { BUY_ASSET_IN_FIAT } from "../pages/ProductDetail/graphql/buy-asset-in-fiat.mutation";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import axios from "axios";
import { VApplication } from "../application";
import { themeConfig } from "../providers/theme";
import { DETAIL_DATA } from "./test-data/product.detail";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { DEFAULT_APP_CONFIG } from "../config/default.config";
import { EventBusModule } from "@vlinder-web/event-bus-module-react";

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export const FIAT_TX_SUCCESS = "fiat-service.tx-success";
export const FIAT_RAZORPAY_TX_ERROR = "fiat-service.tx-razorpay-rror";
export const FIAT_TX_ERROR = "fiat-service.tx-error";
export const FIAT_TX_MODAL_DISMISSED = "fiat-service.modal-dismissed";

const SERVICE_NAME = "AssetService";
const log: any = LoggerModule.getInstance();

export class FiatDetailService {
    private static instance: FiatDetailService;
    private vapp: VApplication;
    private eventbus: any;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.eventbus = EventBusModule?.getInstance()?.getEventBus();
    }
    public static getInstance(props: any = {}): FiatDetailService {
        if (!FiatDetailService.instance) {
            FiatDetailService.instance = new FiatDetailService(props);
        }
        return FiatDetailService.instance;
    }

    async createOrderId(assetId: string, user_profile?: any) {
        const _found = _.find(DETAIL_DATA, { idx: assetId });
        if (_found) {
            const _fiat = _.find(_found.price, { type: "fiat" });
            if (_fiat) {
                //call backend for the asset Id and create a new Order !!
                const orderId = await this.getOrderId({
                    amount: Math.round(_fiat.amount * 100),
                    currency: _fiat.currency,
                });
                const options = this.getOptions({
                    key_id: orderId?.key_id,
                    name: _found?.title,
                    description: _found?.subtitle,
                    image: _found?.img,
                    order_id: orderId?.id, //populate from backend response
                    user_name: user_profile?.name,
                    user_email: user_profile?.email,
                    user_contact: user_profile?.contact,
                    user_address: user_profile?.address,
                    theme: themeConfig?.colors?.primary,
                    backend_endpoint: `${DEFAULT_APP_CONFIG.servers.rest.paymentGatewayServer.baseURL}/success`, // populate verify backend end point
                });
                return options;
            }
        }
    }

    async displayRazorpay(orderId: any) {
        const res = await this.loadScript(
            DEFAULT_APP_CONFIG.servers.rest.paymentGatewayServer.scriptURL
        );

        if (!res) {
            throw Error("Are you online?");
        }
        //@ts-ignore
        const paymentObject = new window.Razorpay(orderId);
        paymentObject?.on("payment.failed", (response: any) => {
            this.eventbus?.emit(FIAT_RAZORPAY_TX_ERROR, null, {
                message: response.error?.reason,
            });

            // alert(response.error.code);
            // alert(response.error.description);
            // alert(response.error.source);
            // alert(response.error.step);
            // alert(response.error.reason);
            // alert(response.error.metadata.order_id);
            // alert(response.error.metadata.payment_id);
        });
        paymentObject.open();
    }

    private async getOrderId(order: any) {
        try {
            const res = await axios.post(
                `${DEFAULT_APP_CONFIG.servers.rest.paymentGatewayServer.baseURL}/orders`,
                order
            );
            return res?.data;
        } catch (err) {
            console.log("error in order id ", err);
        }
    }

    private loadScript(src: any) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }

    private getOptions({
        key_id,
        amount,
        currency,
        name,
        description,
        image,
        order_id,
        user_name,
        user_email,
        user_contact,
        user_address,
        theme,
        backend_endpoint,
    }: any) {
        let options: any = {
            key: key_id,
            amount: amount?.toString(),
            currency: currency,
            order_id: order_id,
            modal: {
                ondismiss: () => {
                    this.eventbus?.emit(FIAT_TX_MODAL_DISMISSED, null, {});
                },
            },
        };
        if (name) {
            options.name = name;
        }
        if (description) {
            options.description = description;
        }
        if (image) {
            options.image = { logo: image };
        }
        options.handler = async (response: any) => {
            const data: any = {
                orderCreationId: order_id,
                razorpayPaymentId: response.razorpay_payment_id,
                razorpayOrderId: response.razorpay_order_id,
                razorpaySignature: response.razorpay_signature,
            };
            try {
                const result = await axios.post(backend_endpoint, data);
                if (result?.data) {
                    this.eventbus?.emit(FIAT_TX_SUCCESS, null, result?.data);
                }
            } catch (error: any) {
                console.log(
                    "error in fiat transaction verificaiton",
                    error?.message
                );
                this.eventbus?.emit(FIAT_TX_ERROR, null, {
                    message: error?.message,
                });
            }
        };
        if (user_name || user_email || user_contact) {
            if (user_name) {
                options.prefill = {
                    name: user_name,
                };
            }
            if (user_email) {
                options.prefill = {
                    ...(options.prefill || {}),
                    email: user_email,
                };
            }
            if (user_contact) {
                options.prefill = {
                    ...(options.prefill || {}),
                    contact: user_contact,
                };
            }
        }
        if (user_address) {
            options.notes = {
                address: user_address,
            };
        }
        if (theme) {
            options.theme = {
                color: theme,
            };
        }
        return options;
    }
}
